import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LanguageIcon from '@mui/icons-material/Language';

import {
  Box,
  Button,
  Menu,
  MenuItem
} from '@mui/material';

import HelpersLanguage from '../../actions/helpers/language';

type Props = {
  sx?: any;
  black?: boolean;
  fullLang?: boolean;
};

export const LanguagePicker: FunctionComponent<Props> = ({sx, black, fullLang}) => {
  const {t, i18n} = useTranslation(['translations']);

  const [langMenuOpen, setLangMenuOpen] = useState<boolean>(false);
  const [langMenuAnchor, setLangMenuAnchor] = useState<null | HTMLElement>(null);

  return (<Box sx={{
    ...sx
  }}>
    <Button onClick={(event) => {
      setLangMenuOpen(true);
      setLangMenuAnchor(event.currentTarget);
    }} sx={{
      ...(!!black ? {
        color: 'rgba(0, 0, 0, 0.87)'
      } : {})
    }} startIcon={<LanguageIcon />}>{!!fullLang ? HelpersLanguage.iso_to_full(i18n.resolvedLanguage) : i18n.resolvedLanguage}</Button>
    <Menu
      id="lang-appbar"
      anchorEl={langMenuAnchor}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={langMenuOpen}
      onClose={() => {
        setLangMenuOpen(false);
      }}
    >
      {HelpersLanguage.available_locales().map((locale, i) => (<MenuItem key={i} onClick={() => {
        i18n.changeLanguage(locale);
        setLangMenuOpen(false);
        setLangMenuAnchor(null);
      }}>{!!fullLang ? HelpersLanguage.iso_to_full(locale) : locale.toUpperCase()}</MenuItem>))}
    </Menu>
  </Box>);
}